import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { IGridResult } from 'src/app/core/models/base';
import { buildAssignmentsSearchRequest } from '../assignments/assignments-query';
import { IAssignment } from '../models/assignment';
import { AssignmentService } from '../services/assignment.service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentsResolver  {
  constructor(private assignmentService: AssignmentService){}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGridResult<IAssignment[]>> {
    return this.assignmentService.searchAssignments(buildAssignmentsSearchRequest(route.queryParamMap))
    .pipe(
      map(response => {
        return {
          data: response.data,
          total: response.totalCount
        }
      })
    )
  }
}
